var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrongReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#FFE7E6",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1225_59628",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1225_59628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4 28.5L26 25.9L28.6 28.5L30 27.1L27.4 24.5L30 21.9L28.6 20.5L26 23.1L23.4 20.5L22 21.9L24.6 24.5L22 27.1L23.4 28.5ZM16 36.5V18.5C16 17.95 16.1958 17.4792 16.5875 17.0875C16.9792 16.6958 17.45 16.5 18 16.5H34C34.55 16.5 35.0208 16.6958 35.4125 17.0875C35.8042 17.4792 36 17.95 36 18.5V30.5C36 31.05 35.8042 31.5208 35.4125 31.9125C35.0208 32.3042 34.55 32.5 34 32.5H20L16 36.5ZM19.15 30.5H34V18.5H18V31.625L19.15 30.5Z",
    fill: "#FF5757"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrongReport);
export default __webpack_public_path__ + "static/media/icon_wrong_report.6570d71173b325943537fecf94d078cd.svg";
export { ForwardRef as ReactComponent };